                    //<script type="application/javascript">
                                        import Vue from "vue";
                                        import App from '/var/www/deporoot/data/www/depohost.ru/local/templates/depohost/components/bitrix/catalog.section/v-choise-ssl/template.vue';

                    export function init(sel, _data) {
                        const app = new Vue(App)
                        Vue.util.extend(app.$data, _data);
                        app.$mount(sel)
                    }
                    //</script>
                    


// WEBPACK FOOTER //
// ./apps/vue-8pAAKv0bBw8PvR4/src/client-entry.js